module.exports = __webpack_public_path__ + "static/Attentive-205e8ef3833a9407c9d3257b2f44d3bf.jpg";